import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _loading = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this._loading.asObservable().pipe(
    distinctUntilChanged() // Avoids redundant emissions
  );

  show() {
    this._loading.next(true);
  }

  hide() {
    this._loading.next(false);
  }
}
